<template>
  <div>
    <row>
      <col5>
        <v-text-field dense outlined id="label_input" :label="$t('set_labels.label')" style="float: left" v-model="item_name"></v-text-field>
      </col5>
      <col4>
        <v-btn id="add_new_label_button" color="primary" @click="add_item">{{$t('set_labels.btn_add')}}</v-btn>
      </col4>
    </row>
    <row class="mt-2 mb-2">
      <col12>
        <v-btn
          id="export_labels_csv_button"
          color="primary"
          class="mr-2"
          :loading="exporting"
          @click="exportLabelsCsv"
        >
          {{ $t('set_labels.btn_export_csv') }}
        </v-btn>
        <v-btn
          id="import_labels_csv_button"
          color="primary"
          @click="import_mode = true"
        >
          {{ $t('set_labels.btn_import_csv') }}
        </v-btn>
      </col12>
    </row>
    <v-divider></v-divider>
    <import-labels-modal
      v-if="import_mode"
      @close_modal="import_mode = false"
      @imported="onImported"
    ></import-labels-modal>
    <label-list
      id="label_list_component"
      ref="labelList"
      @select_label_ids="select_label_ids"
      :selected_labels_ids="selected_label_ids"
    ></label-list>
  </div>
</template>

<script>
import Row from "@/components/layout/Row";
import Col5 from "@/components/layout/Col5";
import Col12 from "@/components/layout/Col12";
import LabelList from "@/components/manage_labels/LabelList";
import Label from "@/models/label";
import Col4 from "@/components/layout/Col4";
import ImportLabelsModal from "@/components/ImportLabelsModal.vue";
import { labelsToCsv, downloadTextFile } from "@/utils/labelCsv";

export default {
  name: "ManageLabels",
  components: { Col4, Col12, LabelList, Col5, Row, ImportLabelsModal },
  data() {
    return {
      selected_label_ids: [],
      item_name: '',
      import_mode: false,
      exporting: false,
    }
  },
  methods: {
    select_label_ids(label_ids) {
      this.selected_label_ids = label_ids;
    },
    async add_item() {
      if(this.item_name === '') {
        return;
      }
      let label = new Label(false, this.item_name.trim(), 1, '0,99,133', false)
      await this.$store.dispatch('label/add', label)
      await this.$store.dispatch('snackbars/add_success_snack', {
        'message': this.$t('snacks.label_added'),
      })
      this.item_name = '';
      if (this.$refs.labelList && this.$refs.labelList.reloadList) {
        await this.$refs.labelList.reloadList();
      }
    },
    async exportLabelsCsv() {
      this.exporting = true;
      try {
        const labels = await this.$api.label.fetchAllProjectLabelsV2();
        const csv = labelsToCsv(labels);
        const projectId = sessionStorage.getItem('project_id') || 'project';
        downloadTextFile(`box21-labels-${projectId}.csv`, csv);
        this.$store.dispatch('snackbars/add_success_snack', {
          message: this.$t('set_labels.export_success', { n: labels.length }),
        });
      } catch (e) {
        console.error(e);
        this.$store.dispatch('snackbars/add_failed_snack', {
          message: this.$t('set_labels.import_failed'),
        });
      } finally {
        this.exporting = false;
      }
    },
    async onImported() {
      this.import_mode = false;
      if (this.$refs.labelList && this.$refs.labelList.reloadList) {
        await this.$refs.labelList.reloadList();
      }
    },
  },
}
</script>

<style scoped>
</style>
